/**
 * Generated by orval 🍺
 * Do not edit manually.
 * BlyCare Admin API
 * Existing Admin APIs plus Apifox folder 97832196 (B端) from project 8731130.
 * OpenAPI spec version: 1.0.0
 */
import type {
  BaseInfoResponse,
  CfPresignParams,
  CollectionListParams,
  DismissGuideBody,
  ExclusionOptionListResp,
  FulfillmentConfigRequest,
  FulfillmentConfigResponse,
  GetProductSkuParams,
  GetProductTypeListParams,
  GuideProgressResponse,
  LanguageListParams,
  LanguagePreferenceResponse,
  MainStatisticsParams,
  MainStatisticsResponse,
  MarketCountryListParams,
  PresignRsp,
  PriceConfigRequest,
  PriceConfigResponse,
  UpLanguagePreferenceReq,
  UpdateGuideProgressReq,
  UpdatePriceConfig200,
  UpdateWidgetConfig200,
  WidgetConfigRequest,
  WidgetConfigResponse,
} from "./model";

import { adminRequest } from "../http.ts";

// https://stackoverflow.com/questions/49579094/typescript-conditional-types-filter-out-readonly-properties-pick-only-requir/49579497#49579497
type IfEquals<X, Y, A = X, B = never> =
  (<T>() => T extends X ? 1 : 2) extends <T>() => T extends Y ? 1 : 2 ? A : B;

type WritableKeys<T> = {
  [P in keyof T]-?: IfEquals<{ [Q in P]: T[P] }, { -readonly [Q in P]: T[P] }, P>;
}[keyof T];

type UnionToIntersection<U> = (U extends any ? (k: U) => void : never) extends (k: infer I) => void
  ? I
  : never;
type DistributeReadOnlyOverUnions<T> = T extends any ? NonReadonly<T> : never;

type Writable<T> = Pick<T, WritableKeys<T>>;
type NonReadonly<T> = [T] extends [UnionToIntersection<T>]
  ? {
      [P in keyof Writable<T>]: T[P] extends object ? NonReadonly<NonNullable<T[P]>> : T[P];
    }
  : DistributeReadOnlyOverUnions<T>;

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * @summary 获取基础信息
 */
export const baseInfo = (options?: SecondParameter<typeof adminRequest<BaseInfoResponse>>) => {
  return adminRequest<BaseInfoResponse>({ url: `/api/base_info`, method: "GET" }, options);
};

/**
 * Setup guide 卡片右上角 Dismiss 按钮：写库 cart_setting.guide_dismiss=1，永久隐藏引导卡片（不可恢复）。响应携带最新引导状态，前端以 guide_dismiss=true 为准隐藏卡片。
 * @summary 关闭新手引导（Dismiss）
 */
export const dismissGuide = (
  dismissGuideBody?: DismissGuideBody,
  options?: SecondParameter<typeof adminRequest<GuideProgressResponse>>,
) => {
  return adminRequest<GuideProgressResponse>(
    {
      url: `/api/guide/dismiss`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: dismissGuideBody,
    },
    options,
  );
};

/**
 * 仅 setProtectionFee / testWidget 需要记录保存：completed=true 写库且永久生效（completed=false 不会回退）。activateAppEmbed（前端自行检测）/ publishWidget（实时推导）忽略写入。响应始终携带最新步骤状态，前端以响应为准渲染。
 * @summary 上报新手引导步骤完成
 */
export const updateGuideProgress = (
  updateGuideProgressReq: UpdateGuideProgressReq,
  options?: SecondParameter<typeof adminRequest<GuideProgressResponse>>,
) => {
  return adminRequest<GuideProgressResponse>(
    {
      url: `/api/guide/progress`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: updateGuideProgressReq,
    },
    options,
  );
};

/**
 * 保存用户选择的应用界面默认语言，返回保存后的值（前端可直接生效，无需再调 base_info）。language 为必填 locale 代码（如 en、zh-CN、zh-Hans），格式非法返回 400。
 * @summary 保存语言偏好
 */
export const updateLanguagePreference = (
  upLanguagePreferenceReq: UpLanguagePreferenceReq,
  options?: SecondParameter<typeof adminRequest<LanguagePreferenceResponse>>,
) => {
  return adminRequest<LanguagePreferenceResponse>(
    {
      url: `/api/language_preference`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: upLanguagePreferenceReq,
    },
    options,
  );
};

/**
 * @summary 首页运输险统计
 */
export const mainStatistics = (
  params?: MainStatisticsParams,
  options?: SecondParameter<typeof adminRequest<MainStatisticsResponse>>,
) => {
  return adminRequest<MainStatisticsResponse>(
    { url: `/api/analytics`, method: "GET", params },
    options,
  );
};

/**
 * @summary Get widget config
 */
export const getWidgetConfig = (
  options?: SecondParameter<typeof adminRequest<WidgetConfigResponse>>,
) => {
  return adminRequest<WidgetConfigResponse>({ url: `/api/widget_config`, method: "GET" }, options);
};

/**
 * Partial update: fields omitted in config keep their stored values. Scalar fields (widget/plus/custom_url/img_type/css/toggle_format/checkout_button) are untouched when omitted. color_style and size_display merge per sub-object: a passed sub-object (cart/checkout_button/plus) replaces that sub-object entirely, omitted sub-objects keep stored values. language_texts replaces the whole map when passed; within each language, cart/checkout_button also merge per sub-object.
 * @summary Update widget config (partial update)
 */
export const updateWidgetConfig = (
  widgetConfigRequest: WidgetConfigRequest,
  options?: SecondParameter<typeof adminRequest<UpdateWidgetConfig200>>,
) => {
  return adminRequest<UpdateWidgetConfig200>(
    {
      url: `/api/widget_config`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: widgetConfigRequest,
    },
    options,
  );
};

/**
 * @summary Get price config
 */
export const getPriceConfig = (
  options?: SecondParameter<typeof adminRequest<PriceConfigResponse>>,
) => {
  return adminRequest<PriceConfigResponse>({ url: `/api/price_config`, method: "GET" }, options);
};

/**
 * Save price config. If widget or plus is on: create UNLISTED product when missing, otherwise delete options and recreate variants by compute mode.
 * @summary Update price config
 */
export const updatePriceConfig = (
  priceConfigRequest: NonReadonly<PriceConfigRequest>,
  options?: SecondParameter<typeof adminRequest<UpdatePriceConfig200>>,
) => {
  return adminRequest<UpdatePriceConfig200>(
    {
      url: `/api/price_config`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: priceConfigRequest,
    },
    options,
  );
};

/**
 * @summary 获取履约与排除配置
 */
export const getFulfillmentConfig = (
  options?: SecondParameter<typeof adminRequest<FulfillmentConfigResponse>>,
) => {
  return adminRequest<FulfillmentConfigResponse>(
    { url: `/api/fulfillment_config`, method: "GET" },
    options,
  );
};

/**
 * 写入 cart_setting(fulfillment_type/exclusion_type/excluded_hide_widget_show) + shop_setting 黑名单 JSON。
 * @summary 更新履约与排除配置
 */
export const updateFulfillmentConfig = (
  fulfillmentConfigRequest: FulfillmentConfigRequest,
  options?: SecondParameter<typeof adminRequest<void>>,
) => {
  return adminRequest<void>(
    {
      url: `/api/fulfillment_config`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: fulfillmentConfigRequest,
    },
    options,
  );
};

/**
 * exclusion_type=1 时用。value/label 均为 product_type。
 * @summary 排除-商品类型列表
 */
export const getProductTypeList = (
  params?: GetProductTypeListParams,
  options?: SecondParameter<typeof adminRequest<ExclusionOptionListResp>>,
) => {
  return adminRequest<ExclusionOptionListResp>(
    { url: `/api/getProductTypeList`, method: "GET", params },
    options,
  );
};

/**
 * exclusion_type=2 时用。value/label 均为 sku。
 * @summary 排除-SKU 列表
 */
export const getProductSku = (
  params?: GetProductSkuParams,
  options?: SecondParameter<typeof adminRequest<ExclusionOptionListResp>>,
) => {
  return adminRequest<ExclusionOptionListResp>(
    { url: `/api/getProductSku`, method: "GET", params },
    options,
  );
};

/**
 * exclusion_type=3 时用。value=Shopify Collection GID，label=集合标题；可选 products_count。
 * @summary 排除-集合列表
 */
export const collectionList = (
  params?: CollectionListParams,
  options?: SecondParameter<typeof adminRequest<ExclusionOptionListResp>>,
) => {
  return adminRequest<ExclusionOptionListResp>(
    { url: `/api/collectionList`, method: "GET", params },
    options,
  );
};

/**
 * exclusion_type=5 时用。value=locale（如 en/fr），label=语言名称。仅返回已 published 的 shopLocales。
 * @summary 排除-语言列表
 */
export const languageList = (
  params?: LanguageListParams,
  options?: SecondParameter<typeof adminRequest<ExclusionOptionListResp>>,
) => {
  return adminRequest<ExclusionOptionListResp>(
    { url: `/api/languageList`, method: "GET", params },
    options,
  );
};

/**
 * exclusion_type=4 时用。value=国家码（如 US），label=国家名。优先 Storefront localization，失败回退 Admin markets。
 * @summary 排除-市场/国家列表
 */
export const marketCountryList = (
  params?: MarketCountryListParams,
  options?: SecondParameter<typeof adminRequest<ExclusionOptionListResp>>,
) => {
  return adminRequest<ExclusionOptionListResp>(
    { url: `/api/marketCountryList`, method: "GET", params },
    options,
  );
};

/**
 * @summary 获取 CF R2 预签名上传 URL
 */
export const cfPresign = (
  params: CfPresignParams,
  options?: SecondParameter<typeof adminRequest<PresignRsp>>,
) => {
  return adminRequest<PresignRsp>({ url: `/api/cfPresign`, method: "GET", params }, options);
};

export type BaseInfoResult = NonNullable<Awaited<ReturnType<typeof baseInfo>>>;
export type DismissGuideResult = NonNullable<Awaited<ReturnType<typeof dismissGuide>>>;
export type UpdateGuideProgressResult = NonNullable<
  Awaited<ReturnType<typeof updateGuideProgress>>
>;
export type UpdateLanguagePreferenceResult = NonNullable<
  Awaited<ReturnType<typeof updateLanguagePreference>>
>;
export type MainStatisticsResult = NonNullable<Awaited<ReturnType<typeof mainStatistics>>>;
export type GetWidgetConfigResult = NonNullable<Awaited<ReturnType<typeof getWidgetConfig>>>;
export type UpdateWidgetConfigResult = NonNullable<Awaited<ReturnType<typeof updateWidgetConfig>>>;
export type GetPriceConfigResult = NonNullable<Awaited<ReturnType<typeof getPriceConfig>>>;
export type UpdatePriceConfigResult = NonNullable<Awaited<ReturnType<typeof updatePriceConfig>>>;
export type GetFulfillmentConfigResult = NonNullable<
  Awaited<ReturnType<typeof getFulfillmentConfig>>
>;
export type UpdateFulfillmentConfigResult = NonNullable<
  Awaited<ReturnType<typeof updateFulfillmentConfig>>
>;
export type GetProductTypeListResult = NonNullable<Awaited<ReturnType<typeof getProductTypeList>>>;
export type GetProductSkuResult = NonNullable<Awaited<ReturnType<typeof getProductSku>>>;
export type CollectionListResult = NonNullable<Awaited<ReturnType<typeof collectionList>>>;
export type LanguageListResult = NonNullable<Awaited<ReturnType<typeof languageList>>>;
export type MarketCountryListResult = NonNullable<Awaited<ReturnType<typeof marketCountryList>>>;
export type CfPresignResult = NonNullable<Awaited<ReturnType<typeof cfPresign>>>;
